import { Routes } from '@angular/router';

export const DESKTOP_ABOUT_PROJECT_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/project-menu/project-menu.component').then(
        c => c.DesktopProjectMenuComponent,
      ),
  },
  {
    path: 'info',
    loadComponent: () =>
      import('./pages/project-info/project-info.component').then(
        c => c.DesktopAboutProjectInfoComponent,
      ),
  },
  {
    path: 'offer',
    loadComponent: () =>
      import('./pages/project-offer/project-offer.component').then(
        c => c.DesktopAboutProjectOfferComponent,
      ),
  },
  {
    path: 'legal-acts',
    loadComponent: () =>
      import('./pages/legal-acts/legal-acts.component').then(
        c => c.DesktopAboutProjectLegalActsComponent,
      ),
  },
  {
    path: 'press',
    loadComponent: () =>
      import('./pages/project-press/project-press.component').then(
        c => c.DesktopAboutProjectPressComponent,
      ),
  },
  {
    path: 'contacts',
    loadComponent: () =>
      import('./pages/project-contacts/project-contacts.component').then(
        c => c.DesktopAboutProjectContactsComponent,
      ),
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('./pages/project-delete-account/project-delete-account.component').then(
        c => c.DesktopAboutProjectDeleteAccountComponent,
      ),
  },
];
